<template>
  <div style="max-width:800px;">
    <video v-for="(video, index) in videos" :key="index" width="100%" controls>
      <source :src="video.src || video" :type="video.type || 'video/mp4'">
    </video>
  </div>
</template>

<script>
export default {
  props: {
    videos: Array
  }
}
</script>



// WEBPACK FOOTER //
// src/components/answers/Videos/Videos.vue